import Icon from 'veui/components/Icon'

Icon.register({
  trophy: {
    paths: [
      {
        d: 'M672 160h-96V96a32 32 0 00-32-32H224a32 32 0 00-32 32v64H96a32 32 0 00-32 32v96c0 80.92 60.39 148 138.47 158.55A192.63 192.63 0 00352 573.32V672h-96a32 32 0 000 64h256a32 32 0 000-64h-96v-98.68a192.63 192.63 0 00149.53-126.77C643.61 436 704 368.92 704 288v-96a32 32 0 00-32-32zM128 288v-64h64v154.51A96.16 96.16 0 01128 288zm256 224a128.14 128.14 0 01-128-128V128h256v256a128.14 128.14 0 01-128 128zm256-224a96.16 96.16 0 01-64 90.51V224h64z'
      }
    ],
    width: '768',
    height: '768'
  }
})
